var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkUploadBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M21.99 10.84C21.97 10.36 21.89 9.88999 21.74 9.43999C21.05 7.27999 19.03 5.71999 16.65 5.71999H13.86C13.28 5.71999 13.24 5.65998 12.93 5.24998L11.53 3.38998C10.88 2.51998 10.37 1.98999 8.73999 1.98999H6.40997C3.96997 1.98999 1.98999 3.96999 1.98999 6.40999V9.42998V16.64C1.98999 19.59 4.39003 21.99 7.34003 21.99H16.64C19.59 21.99 21.99 19.59 21.99 16.64V11.06C22 11 22 10.91 21.99 10.84Z",
    fill: "#14142A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5801 19.7C13.4701 19.85 13.4701 22.91 15.5801 23.06H20.5901C21.2001 23.06 21.78 22.84 22.23 22.43C23.71 21.14 22.92 18.54 20.97 18.3C20.27 14.08 14.16 15.68 15.61 19.7",
    fill: "#14142A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkUploadBlack);
export default __webpack_public_path__ + "static/media/LinkUploadBlack.c848d13e3d9675ee21bc5207a85c8518.svg";
export { ForwardRef as ReactComponent };